const LOGIN_TYPE = {
  GOOGLE: 'google',
  EMAIL: 'email',
};

const AUTH_TOKEN = 'AUTH_TOKEN';

const MIN_PERCENTAGE_SCROLL_GA = 30;

const BUSINESS_TYPE = {
  TYPE_RETAIL: 1,
  TYPE_SUBSCRIPTION: 2,
};

const SUBSCRIPTION_TYPE = {
  LEARNING_PATH: {
    id: 1,
    value: 'learningPath',
  },
};

const SUBSCRIBE_TYPE = {
  COURSE: {
    id: 0,
  },
  LEARNING_PROGRAM: {
    id: 1,
  },
};

const PRODUCT_TYPE = {
  COURSE: {
    id: 0,
    value: 'course',
    path: 'course',
    title: 'Course',
  },
  EVENT: {
    id: 1,
    path: 'event',
    value: 'event',
    title: 'Event',
  },
  LEARNING_PROGRAM: {
    id: 3,
    path: 'learningPath',
    value: 'learningPath',
    title: 'Learning Program',
  },
  SUBSCRIPTION_PACKAGE: {
    id: 4,
    path: 'subscriptionPackage',
    value: 'subscriptionPackage',
    title: 'Subscription Package',
  },
  MENTORING: {
    id: 5,
    path: 'mentoring',
    value: 'mentoring',
    title: 'Mentoring',
  },
};

export const EVENT_COUNTDOWN = {
  COMING_SOON: 48, // 48 jam (2 hari)
  SOON: 24, // 24 jam (1 hari)
  VERY_SOON: 6, // 6 jam
  IMMINENT: 1, // 1 jam
};
const AVAILABLE_ORDER_TYPES = {
  BUY_COURSE: 'BUY_COURSE',
  SUBSCRIBE_PROGRAM: 'SUBSCRIBE_PROGRAM',
  SUBSCRIBE_ALL: 'SUBSCRIBE_ALL',
};

const COURSE_PROGRESS_ACTIONS = {
  STARTED: 1,
  PAUSED: 2,
  FINISHED: 3,
};

const PRODUCT_TYPE_OPTIONS = Object.values(PRODUCT_TYPE);
const PRODUCT_TYPE_OPTIONS_VALUE = PRODUCT_TYPE_OPTIONS.map((option) => option.value);
const PRODUCT_TYPE_BY_ID = PRODUCT_TYPE_OPTIONS.reduce((acc, value) => {
  return {
    ...acc,
    [value.id]: value,
  };
}, {});

const LEARNING_RESOURCE_TYPE = {
  EMPTY: 0,
  VIDEO: 1,
  AUDIO: 2,
  PDF: 3,
  QUIZ: 4,
  YOUTUBE: 5,
};

const PROMO_TYPE = {
  VOUCHER: 'VOUCHER',
};

const LANGUAGES = {
  INDONESIAN: 'id',
  ENGLISH: 'en',
};

const PAYMENT_STATUS_TYPE = {
  ALL: {
    translationKey: 'payment_status_type.semua',
    label: 'Semua',
    value: '',
  },
  MENUNGGU_PEMBAYARAN: {
    translationKey: 'payment_status_type.menunggu_pembayaran',
    label: 'Menunggu Pembayaran',
    value: -5,
  },
  MENUNGGU_KONFIRMASI: {
    translationKey: 'payment_status_type.menunggu_konfirmasi',
    label: 'Menunggu Konfirmasi',
    value: -4,
  },
  EXPIRED: {
    translationKey: 'payment_status_type.kadaluwarsa',
    label: 'Kedaluwarsa',
    value: -3,
  },
  REJECTED: {
    translationKey: 'payment_status_type.ditolak',
    label: 'Ditolak',
    value: -2,
  },
  CANCELED: {
    translationKey: 'payment_status_type.dibatalkan',
    label: 'Dibatalkan',
    value: -1,
  },
  VERIFIED: {
    translationKey: 'payment_status_type.berhasil',
    label: 'Berhasil',
    value: 0,
  },
};

const PAYMENT_STATUS_TYPE_OPTIONS = Object.values(PAYMENT_STATUS_TYPE);

const PURCHASE_OPTIONS = {
  BUY_LEARNING_PROGRAM: 'BUY_LEARNING_PROGRAM',
  BUY_COURSE: 'BUY_COURSE',
  SUBSCRIBE_ALL: 'SUBSCRIBE_ALL',
  SUBSCRIBE_LEARNING_PROGRAM: 'SUBSCRIBE_LEARNING_PROGRAM',
};

const CATEGORY_DISPLAY_NAMES = {
  event: 'Event',
  course: 'Kursus',
  learningPath: 'Program Belajar',
  learning_program: 'Program Belajar',
  mentoring: 'Mentoring',
  physicalProduct: 'Produk Fisik',
};

const PAYMENT_METHODS = {
  BANK_TRANSFER: {
    value: 98,
    label: 'Bank Transfer',
  },
  PAYMENT_XENDIT: {
    value: 41,
    label: 'Payment Gateway',
  },
  DEPOSIT: {
    value: 20,
    label: 'Deposit',
  },
  VOUCHER: {
    value: 1,
    label: 'Voucher',
  },
  COUPON: {
    value: 2,
    label: 'Coupon',
  },
  PUT: {
    value: 23,
    label: 'Put',
  },
  COMMUNITY: {
    value: 4,
    label: 'Community',
  },
  MAIN_VOUCHER: {
    value: 11,
    label: 'Main Voucher',
  },
};

const PAYMENT_METHOD_OPTIONS = Object.values(PAYMENT_METHODS);
const PAYMENT_METHOD_BY_VALUE = PAYMENT_METHOD_OPTIONS.reduce((acc, method) => {
  return { ...acc, [method.value]: method.label };
}, {});
const AVAILABLE_PAYMENT_METHODS = [PAYMENT_METHODS.PAYMENT_XENDIT];
const AVAILABLE_PAYMENT_METHODS_BY_VALUE = AVAILABLE_PAYMENT_METHODS.reduce((acc, method) => {
  return { ...acc, [method.value]: method.label };
}, {});

const MONTHS = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
];

export const CONSTANTS = {
  EVENT_COUNTDOWN,
  AUTH_TOKEN,
  MIN_PERCENTAGE_SCROLL_GA,
  LOGIN_TYPE,
  BUSINESS_TYPE,
  COURSE_PROGRESS_ACTIONS,
  SUBSCRIBE_TYPE,
  PRODUCT_TYPE,
  PRODUCT_TYPE_OPTIONS,
  PRODUCT_TYPE_OPTIONS_VALUE,
  PRODUCT_TYPE_BY_ID,
  LEARNING_RESOURCE_TYPE,
  LANGUAGES,
  PROMO_TYPE,
  PAYMENT_STATUS_TYPE,
  PAYMENT_STATUS_TYPE_OPTIONS,
  PAYMENT_METHODS,
  PAYMENT_METHOD_BY_VALUE,
  PURCHASE_OPTIONS,
  AVAILABLE_PAYMENT_METHODS,
  AVAILABLE_PAYMENT_METHODS_BY_VALUE,
  AVAILABLE_ORDER_TYPES,
  MONTHS,
  SUBSCRIPTION_TYPE,
  CATEGORY_DISPLAY_NAMES,
};
